import React, { Fragment, useEffect, useState } from 'react'
import {
    useGetInvitesMutation,
    useSendInviteMutation,
    useResendInviteMutation,
} from '../../Redux/Admin_Tasks/InviteSlice'
import Dialog from '../../GenericComponents/dialog'
import { createListenerMiddleware } from '@reduxjs/toolkit'
import { useNavigate } from 'react-router-dom'
import { FormValidation } from '../../FormValidationsRules'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { useTitleContext } from "../../Hooks/useTitleContext";


declare let window: any
const UnicornApp = window.unicornInstance as any
interface Invitee {
    EmailAddress: string
    EmailGuid: string
    FirstName: string
    LastName: string
    Status: string
    CreatedOn: string
    LastUpdatedOn: string
}
interface invitees {
    FirstName: string
    LastName: string
    EmailAddress: string
}
export interface InviteesDTO {
    invitees: invitees[]
    message?: string
}

const Invite: React.FC = () => {

    const { setTitle } = useTitleContext();
    setTitle("Invite");

    const [inviteList, setInviteList] = useState<Invitee[] | null>(null) // Set initial state to null
    const [isInvitePanelVisible, setIsInvitePanelVisible] = useState(false)
    const [errors, setErrors] = useState<Record<string, string>>({})
    const initialFormData = [
        { FirstName: '', LastName: '', EmailAddress: '' },
        { FirstName: '', LastName: '', EmailAddress: '' },
        { FirstName: '', LastName: '', EmailAddress: '' },
    ]
    const defaultMessage = "I've been using Foundations from HealthLevel and thought you might like to try it out. Here's an invitation to create an account.";
    const [formData, setFormData] = useState<invitees[]>(initialFormData)
    const [reloadTable, setReloadTable] = useState(false)
    const [message, setMessage] = useState<string>(defaultMessage)
    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const [GetInvites, { error: getInvitesError, isLoading: getInvitesLoading }] =
        useGetInvitesMutation()
    const [SendInvite, { error: sendInvitesError, isLoading: sendInvitesLoading }] =
        useSendInviteMutation()
    const [ResendInvite, { error: resendInvitesError, isLoading: resendInvitesLoading }] =
        useResendInviteMutation()

        const options: Intl.DateTimeFormatOptions = {
            weekday: "long",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hourCycle: "h23", // 24-hour format
          };    

    const prettifyDate = (dateString: string) => {
        const date = new Date(dateString);
        const formattedDate = date.toLocaleDateString("en-GB", options);
        return formattedDate;
    }

    useEffect(() => {
        const fetchInvites = async () => {
            try {
                const res = await GetInvites()
                setInviteList(res.data)
            } catch (error) {
                console.error('Error fetching invites:', error)
            }
        }

        fetchInvites()
    }, [reloadTable])

    const handleEmailValidation = (index: number, value: string) => {
        const newErrors = { ...errors }
        const key = `textEmailAddress_${index}`
        // Check if the field is empty or not.
        if (value === "") {
            delete newErrors[key]; // Remove any previous error if the field is empty
        }
        // Check if the email matches the pattern (pattern validation)
        else if (!FormValidation.email.pattern.value.test(value)) {
            newErrors[key] = FormValidation.email.pattern.message; // Use the pattern message from the validation rules
        }
        // Check if the email exceeds the maxLength (maxLength validation)
        else if (value.length > FormValidation.email.maxLength.value) {
            newErrors[key] = FormValidation.email.maxLength.message; 
        } else {
            delete newErrors[key]
        }
        setErrors(newErrors)
    }

    const sendInvite = () => {

        if (sendInvitesLoading || Object.keys(errors).length > 0) {
            return
        }
        var isValid = true;
        const filteredData = formData.filter(
            (invite) =>
                invite.FirstName.trim() !== '' &&
                invite.LastName.trim() !== '' &&
                invite.EmailAddress.trim() !== ''
        )
        if (filteredData.length===0) {
        for (let invite of formData) {
            if (
                (invite.FirstName.trim() !== '' && (invite.LastName.trim() === '' || invite.EmailAddress.trim() === '')) ||
                (invite.LastName.trim() !== '' && (invite.FirstName.trim() === '' || invite.EmailAddress.trim() === '')) ||
                (invite.EmailAddress.trim() !== '' && (invite.FirstName.trim() === '' || invite.LastName.trim() === ''))
            ) {
                isValid = false;  // If any object has only one or two fields filled, mark isValid as false.
                break;  // Exit the loop once we find an invalid entry
            }
        }
        if (filteredData.length==0||!isValid) {
            FoundationsGenericToaster(
                'error',
                'Please enter at least one name and email address to send invite to.'
            )
        }
        }
        

        const payload: InviteesDTO = {
            invitees: filteredData.map((invite) => ({
                FirstName: invite.FirstName,
                LastName: invite.LastName,
                EmailAddress: invite.EmailAddress,
            })),
            message,
        }
        if (filteredData.length !=0 && isValid) {
            setIsProcessing(true)
            SendInvite(payload)
            .unwrap()
            .then((res) => {
                if (res.statusCode == 201 && res.statusMessage == 'Success') {
                    const toastMessage = filteredData.length === 1
                    ? 'Your invite has been sent successfully.'
                    : 'Your invites have been sent successfully.';
                    FoundationsGenericToaster('success', toastMessage);
                    setReloadTable((prev) => !prev) // Trigger table reload
                    setFormData(initialFormData);
                    setMessage(defaultMessage);
                    setIsInvitePanelVisible(false)
                    setIsProcessing(false);
                } else {
                    FoundationsGenericToaster('error', 'Sending invite failed. Please try again.')
                }
            })
        }
    }

    const handleReinvite = (firstName: string, lastName: string, email: string) => {
        if (resendInvitesLoading) {
            return
        }
        const reInviteReqObject = {
            FirstName: firstName,
            LastName: lastName,
            EmailAddress: email,
            EmailMessage:
                "I've been using Foundations from HealthLevel and thought you might like to try it out. Here's an invitation to create an account.",
        }
        ResendInvite(reInviteReqObject)
            .unwrap()
            .then((res) => {
                if (res.statusCode == 204 && res.statusMessage == 'Success') {
                    FoundationsGenericToaster('success', 'Your invite has been sent successfully.')
                    setReloadTable((prev) => !prev) // Trigger table reload
                } else {
                    FoundationsGenericToaster('error', 'Resending invite failed. Please try again.')
                }
            })
    }

    const handleChange = (index: number, field: keyof invitees, value: string) => {
        const updatedFormData = [...formData]
        updatedFormData[index][field] = value
        setFormData(updatedFormData)
    }

    const handleCancel = () => {
        setIsInvitePanelVisible(!isInvitePanelVisible)
        setFormData(initialFormData)
        setMessage(defaultMessage);
        setErrors({})
    }
    return (
        <div>
            <div className="float-right strong invite-send-link">
                <a
                    id="anchorSendInvites"
                    className="cursor-pointer"
                    onClick={() => setIsInvitePanelVisible(true)}
                >
                    Send Invites
                </a>
            </div>

            <div className="header">Invite Colleagues</div>

            <table id="tableInvitees" className="admin-table">
                <thead>
                    <tr className="admin-row-header">
                        <td style={{ width: '220px' }}>Invitee Full Name</td>
                        <td>Email Address</td>
                        <td>Status</td>
                        <td>Invited On</td>
                        <td>Actions</td>
                    </tr>
                </thead>
                <tbody>
                    {inviteList === null ? null : inviteList.length > 0 ? (
                        inviteList.map((invitee, index) => (
                            <tr key={index} className={index % 2 === 0 ? "admin-row-data" : "admin-alt-row-data"}>
                                <td>{`${invitee.FirstName} ${invitee.LastName}`}</td>
                                <td>{invitee.EmailAddress}</td>
                                <td>{invitee.Status}</td>
                                <td>{prettifyDate(invitee.LastUpdatedOn)}</td>
                                {['Invited', 'Re-invited'].includes(invitee.Status) ? (
                                    <td className="sub-info">
                                        <a
                                            className="resend-invite"
                                            onClick={() =>
                                                handleReinvite(
                                                    invitee.FirstName,
                                                    invitee.LastName,
                                                    invitee.EmailAddress
                                                )
                                            }
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Re-invite
                                        </a>
                                    </td>
                                ) : (
                                    <td className="sub-info">-</td>
                                )}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={5}>
                                You haven't invited anyone.{' '}
                                <a
                                    className="invite-send-link cursor-pointer"
                                    onClick={() => setIsInvitePanelVisible(true)}
                                >
                                    Invite
                                </a>{' '}
                                now.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {isInvitePanelVisible && (
                <>
                <Dialog
                    isOpen={isInvitePanelVisible}
                    title="Send Invites"
                    width={650}
                    onClose= {handleCancel}
                    buttons={[
                        {
                            label: 'Cancel',
                            onClick: handleCancel,
                            className: 'ui-button ui-corner-all ui-widget app-button negative',
                        },
                        {
                            label: 'Send Invites',
                            onClick: sendInvite,
                            className: 'ui-button ui-corner-all ui-widget app-button',
                        },
                    ]}
                >
                    <div id="Panel_SendInvites">
                        <table className="input-form-table-popup-window" style={{ width: '98%' }}>
                            <thead>
                                <tr className="invite-row-header">
                                    <td>First Name</td>
                                    <td>Last Name</td>
                                    <td>Email Address</td>
                                </tr>
                            </thead>
                            <tbody>
                                {formData.map((row, index) => (
                                    <tr key={index} className="invite-row-data">
                                        <td>
                                            <input
                                                type="text"
                                                id={`textFirstName_${index}`}
                                                maxLength={50}
                                                size={10}
                                                className="field-invite-name"
                                                aria-autocomplete="list"
                                                value={formData[index].FirstName}
                                                onChange={(e) =>
                                                    handleChange(index, 'FirstName', e.target.value)
                                                }
                                            />
                                            <div
                                                id={`valMsg_textFirstName_${index}`}
                                                className="field-validation-error"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                id={`textLastName_${index}`}
                                                maxLength={50}
                                                size={10}
                                                className="field-invite-name"
                                                aria-autocomplete="list"
                                                value={formData[index].LastName}
                                                onChange={(e) =>
                                                    handleChange(index, 'LastName', e.target.value)
                                                }
                                            />
                                            <div
                                                id={`valMsg_textLastName_${index}`}
                                                className="field-validation-error"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                id={`textEmailAddress_${index}`}
                                                maxLength={50}
                                                size={10}
                                                className="on_key_press_enter field-invite-email"
                                                aria-autocomplete="list"
                                                value={formData[index].EmailAddress}
                                                onChange={(e) => {
                                                    handleChange(index, 'EmailAddress', e.target.value);
                                                    handleEmailValidation(index, e.target.value); 
                                                }}
                                            />
                                            <div
                                                id={`valMsg_textEmailAddress_${index}`}
                                                className="field-validation-error"
                                                style={
                                                    errors[`textEmailAddress_${index}`]
                                                        ? { display: 'block' }
                                                        : { display: 'none' }
                                                }
                                            >
                                                {errors[`textEmailAddress_${index}`]}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                <tr className="invite-row-data">
                                    <td colSpan={3}>
                                        <div className="padding-top-large"></div>
                                        <span className="strong">
                                            Add a note to the invitation
                                        </span>{' '}
                                        <span className="padding-left-small">(optional)</span>
                                        <br />
                                        <textarea
                                            id="textareaInviteMessage"
                                            rows={4}
                                            cols={80}
                                            className="field-invite-message"
                                            value={message}
                                            defaultValue={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            style={{ minHeight: '100px' }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div
                            id="valMsg_SendInvites"
                            className="padding-left-small field-validation-error"
                        />
                        {isProcessing && (
                        <span
                            id="sendInvite_Loading"
                            className="ajax-loading-box popup-loading"
                        >
                            <span className="ajax-loading-image">Processing...</span>
                        </span>
                        )}
                    </div>
                </Dialog>
                </>
            )}

            <div className="padding-top-large"></div>
            <div className="padding-top-large"></div>
        </div>
    )
}

export default Invite
